<template>
<div class="chapter">
<div class="inner_page">
<p class="ct3"><a id="page_iii"> <b>Also in the Sean Coleman Thriller series from John A. Daly</b></a></p><a id="page_iii">
<p class="txc"><i>From a Dead Sleep</i></p>
<p class="txc"><i>Blood Trade</i></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter01.vue?87da1f92